import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defineMessages } from 'react-intl';
import { isBlank } from 'helpers/verify';
var messages = defineMessages({
  minimumFieldLength: {
    id: 'validators.length.tooShort',
    defaultMessage: 'Field must be at least {minLength} characters long.'
  }
});
export var minLengthValidator = function minLengthValidator(minLength, val) {
  var str = "".concat(val).trim();

  if (isBlank(str) || str.length < minLength) {
    return _objectSpread({}, messages.minimumFieldLength, {
      values: {
        minLength: minLength
      }
    });
  }
};